// Detect whether the graphic is running inside the app platform (?platform=app).
//
// Checked in two places so it works both in production and in dev/preview:
//   1. This frame's own URL — in production the child/graphic URL carries the param.
//   2. Pym's `parentUrl` param — Pym passes the parent page URL down to the child,
//      so `?platform=app` on the parent propagates without needing to be forwarded
//      onto the child URL directly.
export const isAppPlatform = () => {
  if (typeof window === 'undefined') return false;

  const ownParams = new URLSearchParams(window.location.search);
  if (ownParams.get('platform') === 'app') return true;

  const parentUrl = ownParams.get('parentUrl');
  if (parentUrl) {
    try {
      const parentParams = new URL(parentUrl).searchParams;
      if (parentParams.get('platform') === 'app') return true;
    } catch (e) {
      // Ignore a malformed parentUrl and fall through.
    }
  }

  return false;
};

export const isDark = () => {
  if (typeof window === 'undefined') return false;
  if (!isAppPlatform()) return false;

  const ownParams = new URLSearchParams(window.location.search);
  if (ownParams.get('dark') === 'true') return true;

  const parentUrl = ownParams.get('parentUrl');
  if (parentUrl) {
    try {
      const parentParams = new URL(parentUrl).searchParams;
      if (parentParams.get('dark') === 'true') return true;
    } catch (e) {
      // Ignore a malformed parentUrl and fall through.
    }
  }

  return false;
};
